// components/DailyReport/SupervisorSelectionDialog.tsx
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  TextField,
  InputAdornment,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import { Member } from '../../types/member';
import { buildMemberShortName } from '../../utils/memberDisplay';

interface SupervisorSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  members: Member[];
  onSupervisorSelect: (supervisor: string) => void;
  currentSupervisor?: string;
}

export const SupervisorSelectionDialog: React.FC<SupervisorSelectionDialogProps> = ({
  open,
  onClose,
  members,
  onSupervisorSelect,
  currentSupervisor
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredMembers = members.filter(member => {
    const searchText = `${member.LastName}${member.FirstName}${member.staff_initial || ''}`.toLowerCase();
    return searchText.includes(searchQuery.toLowerCase());
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableRestoreFocus
    >
      <DialogTitle sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'grey.50',
        px: 3,
        py: 2
      }}>
        職長選択
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Grid container spacing={1.5}>
          {[...filteredMembers]
            .sort((a, b) => (a.ID ?? 0) - (b.ID ?? 0))
            .map((member) => {
              const supervisorName = buildMemberShortName(member, members);
              const isSelected = currentSupervisor === supervisorName;
              return (
                <Grid item xs={4} key={`supervisor-${member.ID}`}>
                  <Button
                    fullWidth
                    variant={isSelected ? "contained" : "outlined"}
                    color={isSelected ? "success" : "primary"}
                    onClick={() => {
                      onSupervisorSelect(supervisorName);
                      onClose();
                    }}
                    sx={{
                      height: '60px',
                      whiteSpace: 'normal',
                      lineHeight: 1.2,
                      textTransform: 'none',
                      ...(isSelected && {
                        fontWeight: 'bold',
                        boxShadow: 1,
                      }),
                    }}
                  >
                    <Box>
                      <Typography variant="body1">{supervisorName}</Typography>
                    </Box>
                  </Button>
                </Grid>
              );
            })}
        </Grid>
      </DialogContent>
      <DialogActions sx={{
        borderTop: 1,
        borderColor: 'divider',
        px: 3,
        py: 2
      }}>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};